import { render } from "./TopBarNotificationWidget.vue?vue&type=template&id=4621e6eb"
import script from "./TopBarNotificationWidget.vue?vue&type=script&lang=js"
export * from "./TopBarNotificationWidget.vue?vue&type=script&lang=js"

import "./TopBarNotificationWidget.vue?vue&type=style&index=0&id=4621e6eb&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__